import { PanelSharedCssClassName } from '@atlaskit/editor-common/panel';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createSelectionClickHandler } from '@atlaskit/editor-common/selection';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { getPanelNodeView } from '../nodeviews/panel';
import { pluginKey } from '../types';
import { handleCut } from '../utils';
export var createPlugin = function createPlugin(dispatch, providerFactory, pluginOptions) {
  var _pluginOptions$useLon = pluginOptions.useLongPressSelection,
    useLongPressSelection = _pluginOptions$useLon === void 0 ? false : _pluginOptions$useLon;
  return new SafePlugin({
    key: pluginKey,
    appendTransaction: function appendTransaction(transactions, oldState, newState) {
      if (getBooleanFF('platform.editor.allow-custom-cut-for-panel')) {
        var tr = transactions.find(function (tr) {
          return tr.getMeta('uiEvent') === 'cut';
        });
        if (tr) {
          return handleCut(newState, oldState);
        }
      }
    },
    props: {
      nodeViews: {
        panel: getPanelNodeView(pluginOptions, providerFactory)
      },
      handleClickOn: createSelectionClickHandler(['panel'], function (target) {
        return !!target.closest(".".concat(PanelSharedCssClassName.prefix));
      }, {
        useLongPressSelection: useLongPressSelection
      })
    }
  });
};